module.exports = __webpack_public_path__ + "static/media/provider_evolution.0a012978.jpg";